import React, { useState } from "react";
import NavbarInnerCircle from "../NavbarInnerCircle/NavbarInnerCircle";

const VerticalNavbar = (props) => {
  const {
    first,
    handleNavbarClick,
    clickState,
    navbarNumber,
    active,
    textArab,
    textEng,
    handleMovingToLandingPage,
    navbarEducator,
  } = props;
  const [navbarDirection, setNavbarDirection] = useState();
  const [hover, setHover] = useState(false);

  const handleClick = () => {
    setNavbarDirection(clickState ? "navbar-left-right" : "navbar-right-left");
  };

  return (
    <div
      className={`vertical-navbar ${!first && navbarDirection}`}
      style={{
        backgroundColor: first ? "#FF0000" : "",
        borderRightWidth: clickState && "1px",
        borderLeft: first ? "0" : clickState && "none",
        ["--var"]:
          navbarNumber === 1
            ? "slide"
            : navbarNumber === 2
              ? "slide2"
              : "slide3",
        ["--var2"]:
          navbarNumber === 1
            ? "reverseSlide"
            : navbarNumber === 2
              ? "reverseSlide2"
              : "reverseSlide3",
      }}
      onClick={() => {
        !first && handleClick();
        !first && handleNavbarClick(!clickState, navbarNumber);
        first && handleMovingToLandingPage(!clickState, navbarNumber);
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <NavbarInnerCircle
        navbarNumber={navbarNumber}
        first={first}
        active={active}
        clickState={clickState}
        navbarEducator={navbarEducator}
        hover={hover}
      />
      <div className="vertical-navbar-div">
        <div
          className="vertical-navbar-arabic"
          style={{ color: first ? "white" : "black" }}
        >
          <div className="vertical-navbar-arabic-arab">{textArab}</div>
          <div className="vertical-navbar-arabic-eng">{textEng}</div>
        </div>
      </div>
    </div>
  );
};

export default VerticalNavbar;
